import WalletConnectProvider from "@walletconnect/web3-provider";

var _provider = null;

const activate = async () => {
  const chainId = process.env.REACT_APP_ETH_CHAIN_ID;

  _provider = new WalletConnectProvider({
    chainId: chainId,
    rpc: {
      [chainId]: process.env.REACT_APP_ETH_RPC_URL,
    },
  });

  await _provider.enable();

  return _provider;
};

const getAddress = () => {
  return _provider.accounts[0];
};

const subscribeOnEvents = (onAccountChanged) => {
  const accountsChanged = "accountsChanged";
  _provider.removeAllListeners(accountsChanged);
  _provider.on(accountsChanged, (accounts) => {
    onAccountChanged(accounts[0]);
  });

  const disconnect = "disconnect";
  _provider.removeAllListeners(disconnect);
  _provider.on(disconnect, () => {
    onAccountChanged(null);
  });
};

const deactivate = () => {
  _provider.disconnect();
};

export { activate, deactivate, subscribeOnEvents, getAddress };
